/**
 * Unified section item component for Topical Risk drawer.
 * Provides a hoverable container with label, content, status indicator, and action button.
 */
import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { CONTAINER_SX } from './drawerSharedStyles'

export interface DrawerSectionItemProps {
  label?: string
  header?: string
  children: React.ReactNode
  titleColor?: 'text.primary' | 'text.disabled' | 'text.secondary'
  statusElement?: React.ReactNode
  actionButton?: React.ReactNode
  sx?: object
}

export const DrawerSectionItem: React.FC<DrawerSectionItemProps> = ({
  label,
  header,
  children,
  titleColor = 'text.secondary',
  statusElement,
  actionButton,
  sx,
}) => {
  return (
    <Box className="result-item" sx={{ ...CONTAINER_SX, ...sx }}>
      {header && (
        <Typography variant="subtitle1" sx={{ pt: 2 }} gutterBottom>
          {header}
        </Typography>
      )}
      {label && (
        <Typography variant="body1" color="text.primary" sx={{ mb: 0.5 }}>
          {label}
        </Typography>
      )}
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
        <Box sx={{ mt: '2px', mr: 2 }}>
          {typeof children === 'string' ? (
            <Typography variant="body1" color={titleColor}>
              {children}
            </Typography>
          ) : (
            children
          )}
        </Box>
        {statusElement}
      </Stack>
      {actionButton && <Box className="show-on-hover">{actionButton}</Box>}
    </Box>
  )
}

export default DrawerSectionItem
